import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e355b398"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1))
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col DisplacementCreateEditDialog_subTableFirstColumn" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Продольное смещение", -1))
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "col DisplacementCreateEditDialog_subTableSecondColumn" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Поперечное смещение", -1))
const _hoisted_8 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    "max-width": "1200px",
    onOnShown: _ctx.onShown,
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Наименование...",
          "show-clear-button": true,
          value: model.name,
          "onUpdate:value": ($event: any) => ((model.name) = $event),
          hasEmptyValue: false,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            class: "DisplacementCreateEditDialog_longitudinalSubGrid",
            id: _ctx.longitudinalSubGridDomId
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", {
            class: "DisplacementCreateEditDialog_transverseSubGrid",
            id: _ctx.transverseSubGridDomId
          }, null, 8, _hoisted_8)
        ])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback", "onOnShown"]))
}